<template>
  <ProjectScaffold>
    PROJECT ORIGIN
  </ProjectScaffold>
</template>

<style lang="scss" scoped></style>

<script>
import { mapState, mapActions } from 'vuex';

import ProjectScaffold from '../ProjectScaffold.vue';

import projectViewHelpers from '@/mixins/projectViewHelpers';

export default {
  mixins: [projectViewHelpers],
  components: {
    ProjectScaffold
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  async mounted() {}
};
</script>
